import { FormItem } from '@scts-ui/component-library';
import { MemberRole } from '@scts/models';
import { Tabs, Tab } from 'react-bootstrap';

interface MemberProps {
  members: MemberRole[];
}

const MemberComponent = (memberProps: MemberProps) => {
  return (
    <div className="d-flex flex-column flex-lg-row flex-wrap">
      <div className="card-body">
        <Tabs>
          {memberProps.members.map((member, index) => (
            <Tab eventKey={index} title={'Member Details'} key={index}>
              <FormItem
                header={'Type: '}
                detail={member.type}
                minWidthHeader={'9.7rem'}
                minWidthDetail={'9.7rem'}
              />
              <FormItem
                header={'Name: '}
                detail={member.firstName + ' ' + member.lastName}
                minWidthHeader={'9.7rem'}
                minWidthDetail={'9.7rem'}
              />
              {member.phoneNumbers &&
                member.phoneNumbers.map((phoneNumber, index) => (
                  <>
                    <FormItem
                      header={'Phone Number:'}
                      detail={phoneNumber.number}
                      minWidthHeader={'9.7rem'}
                      minWidthDetail={'9.7rem'}
                      key={index}
                      isPhone={true}
                    />
                    <FormItem
                      header={'Phone Type:'}
                      detail={phoneNumber.phoneType}
                      minWidthHeader={'9.7rem'}
                      minWidthDetail={'9.7rem'}
                      key={index}
                    />
                  </>
                ))}

              <FormItem
                header={'Email:'}
                detail={member.emailAddress ? member.emailAddress : ''}
                minWidthHeader={'9.7rem'}
                minWidthDetail={'9.7rem'}
                isEmail={true}
              />
            </Tab>
          ))}
        </Tabs>
      </div>
    </div>
  );
};

export default MemberComponent;
